export default __webpack_public_path__ + "static/media/third-strip.21d6ceec.png";